import * as types from "../constants";

const initialState = {
  isLoading: true,
  error: null,
  items: 0,
};

export default function DisseminationRuleAdddReducer(
  state = initialState,
  action
) {
  switch (action.type) {
    case types.GET_DISSEMINATION_RULE_ADD_INIT:
      return { ...state, error: null, isLoading: true };

    case types.GET_DISSEMINATION_RULE_ADD_SUCCESS:
      return { ...state, isLoading: false, items: action.data.data };

    case types.GET_DISSEMINATION_RULE_ADD_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: action.notification.system_message,
      };

    default:
      return state;
  }
}
